import { makeRequest } from '../base/axios.ts'

export default {
  create: (timelineId, value) => {
    const data = {
      rating: {
        timeline_id: timelineId,
        value,
      },
    }
    return makeRequest({
      url: `/api/v1/ratings`,
      method: 'post',
      data,
      requestId: `create-rating-${timelineId}`,
    })
  },
}
